import React from 'react'
import { Novelty, RealEstateDataPageComponentData, TagMediacore } from 'types'

type Props = {
  hidenTags: boolean
  skeleton: boolean
  hidenAuthor: boolean
  isHome: boolean
  novelty: Novelty
  tags: TagMediacore[]
  dispatch: any
  keyIndex?: number
}

const NoveltyCard_3 = (props: Props & RealEstateDataPageComponentData) => {
  const Card = require(`@components/cardsNovelties/1`)?.default
  const { global_data } = props
  const hidenTags = true
  const hidenAuthor = true
  const placeholder = ''
  const upperCaseLink = false
  const dateFormat = ''
  const isHome = props?.isHome
  const { novelty, tags, skeleton, keyIndex } = props

  return (
    <Card
      hidenTags={hidenTags}
      tags={tags}
      skeleton={skeleton}
      hidenAuthor={hidenAuthor}
      isHome={isHome}
      isSummaryCard={true}
      novelty={novelty}
      placeholder={placeholder}
      upperCaseLink={upperCaseLink}
      dateFormat={dateFormat}
      global_data={global_data}
      key={keyIndex}
    />
  )
}

export default NoveltyCard_3
